// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5b96ea82","455":"bc38ef64","977":"ae86b5f6"}[chunkId] + ".chunk.js";
};